import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

import { ExpenseFacade } from '../../+state/expense/expense.facade';

@Component({
  selector: 'sd-portal-deleted-expense-audit-list',
  templateUrl: './deleted-expense-audit-list.component.html',
  styleUrls: ['./deleted-expense-audit-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class DeletedExpenseAuditListComponent implements OnInit {
  constructor(readonly expenseFacade: ExpenseFacade) {}

  ngOnInit() {
    this.expenseFacade.loadDeletedExpenses();
  }
}
